import React, { useEffect, useState } from "react";

function EditableText({ initialText, isEnabled, onSave }) {
  const [text, setText] = useState(initialText);

  // سینک کردن استیت با پراپ جدید اگر initialText تغییر کرد
  useEffect(() => {
    setText(initialText);
  }, [initialText]);

  const handleBlur = () => {
    if (onSave && text !== initialText) {
      onSave(text);
    }
  };

  // اگر isEnabled نال یا undefined باشد، پیش‌فرض را true در نظر می‌گیریم مگر اینکه صریحا false باشد
  const isDisabled = isEnabled === false;

  return (
    <input
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={handleBlur}
      disabled={isDisabled}
      className="InpoterTablo"
      placeholder={initialText}
    />
  );
}

export default EditableText;